<img
  *ngIf="!isError && attachment?.folder"
  [hfSrcset]="attachment.folder + '/' + attachment.thumbnail"
  [alt]="alt || attachment.originalFilename"
  (error)="isError = true"
/>
<i *ngIf="isError || !attachment?.folder" class="material-icons">insert_photo</i>
